import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthService from '../services/AuthService';

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (AuthService.isTokenValid()) navigate(AuthService.consumePostLoginRedirectPath() || '/', { replace: true });
  }, [navigate]);
  const signIn = async (event: React.FormEvent) => {
    event.preventDefault(); setBusy(true); setError('');
    const requested = AuthService.consumePostLoginRedirectPath() || (location.state as any)?.from?.pathname || '/';
    AuthService.setPostLoginRedirectPath(requested);
    try { const session = await AuthService.login(); if (session) navigate(requested, { replace: true }); }
    catch (reason) { setError(reason instanceof Error ? reason.message : 'Unable to sign in.'); setBusy(false); }
  };
  return (
    <div className="login-panel">
      <div className="section-panel"><h1>Graduation Application</h1><p className="mb-0">Sign in with your Single Sign On to continue.</p></div>
      {error && <div className="alert alert-danger mt-3" role="alert">{error}</div>}
      <form onSubmit={signIn} className="text-center mt-4"><Button size="lg" type="submit" disabled={busy}>{busy ? 'Signing in...' : 'Sign In'}</Button></form>
    </div>
  );
}
